// extracted by mini-css-extract-plugin
export default {"container":"coors-feedback_container__2Zpu7","can":"coors-feedback_can__FehBL","invalid":"coors-feedback_invalid__3p99G","valid":"coors-feedback_valid__2znLJ"};